module.exports = __webpack_public_path__ + "media/svg/circle_phone-cd38c095.svg";